// Shared mapping between modules / record entities and their frontend routes.
// Used for deep-linking from the global Notes sidebar and notifications.

export const MODULE_ROUTE = {
  dashboard: "/", activity: "/activity", assetlibrary: "/asset-library",
  products: "/products", suppliersquotes: "/suppliers-quotes", requests: "/requests",
  sponsorship: "/sponsorship",
  seo: "/seo", faq: "/faq", seo_meta: "/seo-meta", theme_design: "/theme-design",
  orchestrator: "/orchestrator",
  help: "/help", settings: "/settings", notes: "/my-notes", reminders: "/my-notes",
};

export const ENTITY_MODULE = {
  asset: "assetlibrary", product: "products", request: "requests", rfq: "suppliersquotes",
  sponsorship: "sponsorship",
};

export const ENTITY_ROUTE = {
  asset: "/asset-library", product: "/products", request: "/requests", rfq: "/suppliers-quotes",
  sponsorship: "/sponsorship",
};

// A link that opens a specific record's drawer (?open=<id> on the module page).
export function recordLink(entityType, entityId) {
  const base = ENTITY_ROUTE[entityType];
  return base && entityId ? `${base}?open=${encodeURIComponent(entityId)}` : null;
}

// Resolve a notification's context blob → a route to navigate to.
export function contextLink(ctx) {
  if (!ctx) return null;
  if (ctx.kind === "record") return recordLink(ctx.entity_type, ctx.entity_id);
  if (ctx.kind === "module") return MODULE_ROUTE[ctx.module] || "/";
  return null;
}

// Broadcast that a record's notes changed so list/card note-status icons refresh.
export function notifyNotesChanged(entityType, entityId) {
  window.dispatchEvent(new CustomEvent("mh:notes-changed", { detail: { entityType, entityId } }));
}

// Open the global Notes sidebar; with a record payload it opens in entity-focus mode.
export function openNotesSidebar(detail) {
  window.dispatchEvent(new CustomEvent("mh:open-notes", { detail: detail || {} }));
}
